import * as React from "react";
import { cn } from "@/lib/utils";
import { HelpIcon } from "@/components/ui/help-icon";
import { Skeleton } from "@/components/ui/skeleton";

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  sub?: React.ReactNode;
  icon?: React.ReactNode;
  info?: string;
  tone?: "default" | "success" | "warning" | "destructive";
  loading?: boolean;
  className?: string;
}

const toneClasses: Record<NonNullable<StatTileProps["tone"]>, string> = {
  default: "text-foreground",
  success: "text-success-text",
  warning: "text-warning-text",
  destructive: "text-destructive-text",
};

export function StatTile({
  label,
  value,
  sub,
  icon,
  info,
  tone = "default",
  loading,
  className,
}: StatTileProps) {
  return (
    <div
      className={cn(
        "rounded-sm border border-border bg-card px-5 py-4",
        className
      )}
    >
      <div className="flex items-center text-xs text-muted-foreground">
        <span className="inline-flex items-center">
          {label}
          {info && <HelpIcon text={info} />}
        </span>
        <div className="flex-1" />
        {icon && <span className="text-muted-foreground">{icon}</span>}
      </div>
      {loading ? (
        <Skeleton className="mt-2 h-7 w-16" />
      ) : (
        <div
          className={cn(
            "mt-2 text-2xl font-semibold tracking-tight tabular-nums",
            toneClasses[tone]
          )}
        >
          {value}
        </div>
      )}
      {sub && !loading && (
        <div className="mt-1 text-xs text-muted-foreground">{sub}</div>
      )}
    </div>
  );
}
